import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'not-found-flight',
  templateUrl: './not-found-flight.component.html',
  styleUrls: ['./not-found-flight.component.scss'],
  standalone: false
})
export class NotFoundFlightComponent implements OnInit {

  constructor(
    private modalService: NgbModal,
    private _router: Router
  ) { }

  ngOnInit() {
  }

  closeModal() {
    this.modalService.dismissAll();
  }

}